import { Product } from "../../../appData/productData"
import { useAppState } from "../../../context/appStateContext"
import { useExpiration } from "../../../context/expirationContext"
import { usePurchase } from "../../../context/purchaseContext"
import useExpirationPricingItems, {
  ExpirationPaywallItem,
} from "../../../hooks/useExpirationPricingItems"
import useQueryParams from "../../../hooks/useQueryParams"
import useStrings from "../../../localization/useStrings"
import Svg from "../../../utils/svg"
import { formatCurrency } from "../../../utils/utils"
import styles from "./ExpirationModernPricingSelection.module.scss"

const ExpirationModernPricingSelection = () => {
  const items = useExpirationPricingItems()

  return (
    <div className={styles.container}>
      {items.map((item, index) => (
        <PaywallButton key={index} item={item} />
      ))}
    </div>
  )
}

interface PaywallButtonProps {
  item: ExpirationPaywallItem
}

const PaywallButton = ({ item }: PaywallButtonProps) => {
  const { actions } = usePurchase()

  const strings = useStrings()
  const extraStyle = item.popular
    ? styles.paywallButtonPopular
    : styles.paywallButtonRegular

  const locale = item.product.priceLocale
  let price = ""

  if (item.popular) {
    price = formatCurrency(item.product.price, locale)
  } else {
    price = formatCurrency(item.product.price, locale)
  }

  const perString =
    item.product.duration == "yearly"
      ? strings.expiration.warmup.perYear
      : strings.expiration.warmup.perMonth

  return (
    <button
      className={`${styles.paywallButton} ${extraStyle}`}
      onClick={() => {
        actions.purchaseProduct(item.product)
      }}
    >
      <div className={styles.paywallButtonContent}>
        {item.popular && <PopularBadge />}
        <div className={styles.paywallButtonContainer}>
          <label className={styles.pricingTitle}>{item.shortTitle}</label>
          <label className={styles.priceLabel}>{price}</label>
          <label className={styles.perMonthLabel}>{perString}</label>
          {item.product.duration != "monthly" && (
            <label className={styles.perYearLabel}>
              {strings.pricePerMonth(
                formatCurrency(item.product.price / 12, locale)
              )}
            </label>
          )}
        </div>
      </div>
    </button>
  )
}

const PopularBadge = () => {
  const strings = useStrings().expiration.warmup

  return (
    <div className={styles.popularContainer}>
      <label className={styles.popularTitle}>{strings.popular}</label>
    </div>
  )
}

export default ExpirationModernPricingSelection
